// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CellsIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CellsIcon" ref={forwardedRef} {...props}>
      <path d="M11.5 3v7.5h-10V4a1 1 0 0 1 1-1zM10 4.5H3V9h7z" />
      <path d="M13 9.75v1.5h4v4.25h-5.75V12h-1.5v3.5H4V12H2.5v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H13v1.5h4v4.25z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CellsIcon = /* @__PURE__ */ Object.assign(CellsIconComponent, {
  displayName: 'CellsIcon',
});
